module.exports = __webpack_public_path__ + "static/media/lu.c858787c.svg";